<template>
  <div class='AdmTop'>
    <div class="left">
      <div class="cont-icon-home">
        <home-icon @click="$router.push('/enb/workspace/')"/>
      </div>
      <div class="cont-icon-menu" @click="showNave=!showNave">
        <menu-icon/>
        <adm-nave @showChildren="newValue => ShowChildren(newValue)" :data="nave" v-if="showNave"/>
      </div>
    </div>
    <div class="rigth">
      <div class="cont-icon-account">
        <user-icon color="#000000" tam="23px"/>
      </div>
    </div>
  </div>
</template>

<script>
import homeIcon from '../icons/homeIcon'
import menuIcon from '../icons/menuIcon'
import userIcon from '../icons/userIcon'
import AdmNave from './AdmNave'
export default {
  name: 'AdmTop',
  components: { homeIcon, menuIcon, userIcon, AdmNave },
  methods: {
    ShowChildren (data) {
      this.recursiveCheck(this.nave, data)
    },
    recursiveCheck (arr, data) {
      arr.forEach(el => {
        console.log(el.id, data.id)
        if(el.id === data.id) {
          if(el.childrens) {
            el.childrens.map(e => {
              e.visible = data.value
            })
          }
        }
        if(el.childrens) {
          this.recursiveCheck(el.childrens, data)
        }
      })
    }
  },
  data () {
    return {
      showNave: false,
      nave: [
        {
          id: 1,
          text: 'Stripe',
          icon: 'cardIcon',
          nivel: 0,
          childrens: [
            {
              id: 2,
              text: 'Assinaturas',
              icon: 'cardIcon',
              nivel: 1,
              visible: false,
              path: '/enb/workspace/signatures'
            }
          ]
        },
        {
          id: 4,
          text: 'Subdomínios',
          icon: 'NetIcon',
          nivel: 0,
          childrens: [
            {
              id: 5,
              text: 'Blacklist',
              icon: 'blockIcon',
              nivel: 1,
              visible: false,
              path: '/enb/workspace/blacklist'
            }
          ]
        },
        {
          id: 3,
          text: 'Contas',
          icon: 'businessIcon',
          nivel: 0,
          path: '/enb/workspace/contas'
        }
      ]
    }
  }
}
</script>

<style scoped>
.AdmTop {
  width: 100%;
  height: 40px;
  display: flex;
  background-color: #EEEEEE;
}
.left {
  width: 50%;
  display: flex;
  justify-content: left;
  align-items: center;
}
.rigth {
  width: 50%;
  display: flex;
  justify-content: right;
  align-items: center;
}
.cont-icon-home {
  width: 40px;
}
.cont-icon-menu {
  width: 30px;
  border-radius: 5px;
  background-color: #CCCCCC;
}
.cont-icon-account {
  width: 40px;
}
</style>
